import Vue from 'vue'
import VueRouter from 'vue-router';
import HomePage from '../components/home/HomePage.vue';
import PostsByCategory from '../components/posts/PostsByCategory.vue';
import PostDetails from '../components/posts/PostDetails.vue'
import Login from '../components/auth/Login.vue';
import PostForm from '../admin/posts/PostForm.vue'
import AdminDashboard from '../admin/posts/AdminDashboard.vue'
import AdminZone from '../admin/posts/AdminZone.vue'
import CategoryPage from '../admin/posts/CategoryPage.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: HomePage,
        name: 'home-page'
    },
    {
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '/admin',
        component: AdminZone,
        children: [
            {
                path: '',
                component: AdminDashboard,
                name: 'admin-dashboard',
            },
            {
                path: 'create',
                component: PostForm,
                name: 'post-form'
            },
            {
                path: 'edit/:id',
                component: PostForm,
                name: 'post-form',
            },
            {
                path: ':category',
                component: CategoryPage,
                name: 'category-page',
                props (route) {
                    return {
                        category: route.params.category,
                    }
                },
            },
        ],
    },
   
    {
        path: '/:category',
        component: PostsByCategory,
        name: 'posts-by-category',
        props (route) {
            return {
                category: route.params.category,
            }
        },
    },
    {
        path: '/:category/:id',
        component: PostDetails,
        name: 'post-details',
        props (route) {
            return {
                category: route.params.category,
                id: route.params.id,
            }
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})


export default router

